@if (isReady()) {
  <canvas
    baseChart
    [data]="chartData()"
    [options]="barChartOptions()"
  ></canvas>
}
